<header
  class="bg-white shadow-sm border-b border-gray-100 h-20 flex items-center justify-between px-8"
>
  <div class="md:hidden">
    <h1 class="text-xl font-black tracking-tighter text-indigo-600">EVNT CRM</h1>
  </div>

  <div class="flex-1"></div>

  <div class="flex items-center gap-6">
    <div class="relative">
      <!-- ICONE NOTIFICACOES -->
      <button
        type="button"
        (click)="toggleNotifications()"
        [class]="
          showNotifications()
            ? 'p-2.5 rounded-xl transition-all relative bg-indigo-50 text-indigo-600'
            : 'p-2.5 rounded-xl transition-all relative text-gray-400 hover:bg-gray-50'
        "
        aria-haspopup="dialog"
        [attr.aria-expanded]="showNotifications()"
        aria-label="Abrir central de notificacoes"
      >
        <lucide-icon [img]="icons.bell" class="w-5 h-5" />
        @if (unreadCount() > 0) {
          <span
            class="absolute -top-1 -right-1 w-5 h-5 bg-rose-500 text-white text-[10px] font-black flex items-center justify-center rounded-full border-2 border-white shadow-lg animate-bounce"
          >
            {{ unreadCount() }}
          </span>
        }
      </button>

      <!-- LISTA DE NOTIFICACOES -->
      @if (showNotifications()) {
        <div
          class="absolute right-0 mt-4 w-96 bg-white rounded-3xl shadow-2xl border border-gray-100 z-[100] overflow-hidden animate-in fade-in slide-in-from-top-5 duration-300"
        >
          <div class="p-5 border-b border-gray-50 bg-gray-50/50 flex justify-between items-center">
            <span class="text-[10px] font-black text-gray-400 uppercase tracking-widest">
              Central de Inteligencia Operacional
            </span>
            <span
              class="text-[9px] bg-indigo-600 text-white px-3 py-1 rounded-full font-black uppercase"
            >
              {{ unreadCount() }} Alertas
            </span>
          </div>

          <div class="max-h-[450px] overflow-auto">
            @if (notifications().length > 0) {
              @for (notification of notifications(); track notification.id) {
                <div
                  (click)="handleMarkAsRead(notification.id)"
                  [class]="
                    !notification.isRead
                      ? 'p-5 border-b border-gray-50 cursor-pointer hover:bg-indigo-50/30 transition relative bg-white'
                      : 'p-5 border-b border-gray-50 cursor-pointer hover:bg-indigo-50/30 transition relative bg-gray-50/20 opacity-60'
                  "
                  role="button"
                  tabindex="0"
                  (keydown.enter)="handleMarkAsRead(notification.id)"
                  (keydown.space)="handleMarkAsRead(notification.id)"
                >
                  @if (!notification.isRead) {
                    <div
                      class="absolute left-1.5 top-1/2 -translate-y-1/2 w-1.5 h-1.5 bg-indigo-600 rounded-full shadow-lg shadow-indigo-600/40"
                    ></div>
                  }

                  <div class="flex justify-between items-start mb-2 ml-3">
                    <span class="text-[9px] font-black uppercase text-indigo-600 tracking-widest"
                      >Acao do Hotel</span
                    >
                    <span class="text-[9px] text-gray-400 font-bold flex items-center gap-1">
                      <lucide-icon [img]="icons.clock" class="w-3.5 h-3.5" />
                      {{ formatTime(notification.date) }}
                    </span>
                  </div>

                  <p
                    class="text-[11px] text-gray-800 font-bold ml-3 leading-relaxed tracking-tight"
                  >
                    {{ notification.message }}
                  </p>

                  <div class="mt-3 flex justify-end ml-3">
                    <button
                      type="button"
                      class="text-[9px] font-black text-gray-400 hover:text-indigo-600 flex items-center gap-1 uppercase tracking-widest transition"
                    >
                      @if (notification.isRead) {
                        <lucide-icon [img]="icons.check" class="w-3.5 h-3.5 text-emerald-500" />
                        Lida
                      } @else {
                        Marcar Leitura
                      }
                    </button>
                  </div>
                </div>
              }
            } @else {
              <div class="p-16 text-center">
                <div
                  class="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100"
                >
                  <lucide-icon [img]="icons.bell" class="w-6 h-6 text-gray-200" />
                </div>
                <p class="text-[10px] font-black uppercase text-gray-300 tracking-widest">
                  Nenhuma atualizacao pendente
                </p>
              </div>
            }
          </div>

          <!-- FECHA NOTIFICACOES -->
          <div class="p-4 border-t border-gray-50 bg-gray-50/50 text-center">
            <button
              type="button"
              class="text-[10px] font-black text-indigo-600 uppercase tracking-widest hover:text-indigo-800 transition"
              (click)="closeNotifications()"
            >
              Fechar Central
            </button>
          </div>
        </div>
      }
    </div>

    <!-- ICONE DE SIDEBAR MOBILE -->
    <button
      type="button"
      class="md:hidden p-2 rounded-xl bg-gray-50 text-slate-900"
      aria-label="Fechar notificacoes"
    >
      <lucide-icon [img]="icons.menu" class="w-6 h-6" />
    </button>
  </div>
</header>
